import { FC } from "react";
import { Box, SystemProps, Text } from "@storyofams/react-ui";

interface LabelProps extends SystemProps {
  isOutOfStock?: boolean;
  isOnTop?: boolean;
}
export const Label: FC<LabelProps> = ({
  isOutOfStock,
  isOnTop = false,
  ...props
}) => {
  return (
    <Box
      bg={isOutOfStock ? "#EEE3D7" : "#D0D5C4"}
      display={"flex"}
      alignItems={"center"}
      borderRadius="4px"
      px="6px"
      top={isOnTop && "-5px"}
      right={isOnTop && "2px"}
      width="max-content"
      height={"16px"}
      position={isOnTop ? "absolute" : "relative"}
      {...props}
    >
      <Text
        fontSize={"8px"}
        fontWeight={700}
        lineHeight={"100%"}
        textColor={isOutOfStock ? "#767473" : "black"}
        letterSpacing={"0.1em"}
        css={{ textTransform: "uppercase" }}
      >
        {!isOutOfStock ? "Meest populair" : "uitverkocht"}
      </Text>
    </Box>
  );
};
